import { Card } from "../../ui/card";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";

export const SocialContentForm = ({ content, update }) => (
  <Card className="p-6 space-y-4">
    <h3 className="font-semibold">Redes sociales</h3>
    <div>
      <Label>Enlace de Instagram</Label>
      <Input
        data-testid="admin-content-social-instagram"
        value={content.social_instagram || ""}
        onChange={(e) => update("social_instagram", e.target.value)}
        placeholder="https://www.instagram.com/tu-cuenta/"
        className="mt-1"
      />
    </div>
    <div>
      <Label>Enlace de Facebook</Label>
      <Input
        data-testid="admin-content-social-facebook"
        value={content.social_facebook || ""}
        onChange={(e) => update("social_facebook", e.target.value)}
        placeholder="https://www.facebook.com/tu-pagina"
        className="mt-1"
      />
    </div>
    <p className="text-xs text-muted-foreground">
      Deja el campo vacío para ocultar ese ícono del sitio.
    </p>
  </Card>
);
